export const routeName = 'ReclamationChangelogPage'

export const route = {
  path: '/reclamation/changelog',
  name: routeName,
  component: () => import('./ReclamationChangelogPage.vue')
}
